import { useQuery } from '@tanstack/react-query'

import { apiRequest } from '../../../../services/api'
import { WhyStockMovingData } from './types'

const WHY_STOCK_MOVING_REFRESH_INTERVAL = 1000 * 60 // 1 minute
const WHY_STOCK_MOVING_STALE_TIME = 1000 * 20 // 20 seconds

function whyStockMovingRequest(ticker: string) {
  return apiRequest<WhyStockMovingData>(`/api/stocks-why-moving/${ticker}`, undefined, true)
}

export function useWhyStockMoving(ticker: string, initialData?: WhyStockMovingData) {
  return useQuery({
    queryKey: ['whyStockMoving', ticker],
    queryFn: () => whyStockMovingRequest(ticker),
    initialData: initialData ?? null,
    refetchInterval: WHY_STOCK_MOVING_REFRESH_INTERVAL,
    refetchIntervalInBackground: false,
    staleTime: WHY_STOCK_MOVING_STALE_TIME,
    useErrorBoundary: false,
  })
}
